/**
 * Monthlees ingredient systems — accordion toggles and image lightbox.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-monthlees-ingredient-systems]').forEach(function (root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var modal = root.querySelector('[data-mis-modal]');
    var modalImage = root.querySelector('[data-mis-modal-image]');
    var modalImageWrap = root.querySelector('.monthlees-ingredient-systems__modal-image-wrap');
    var modalTriggers = root.querySelectorAll('[data-mis-modal-trigger]');
    var modalCloseEls = root.querySelectorAll('[data-mis-modal-close]');

    root.querySelectorAll('.monthlees-ingredient-systems__system-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.monthlees-ingredient-systems__system');
        if (!item) return;

        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    function openModal(src, alt) {
      if (!modal || !modalImage || !src) return;

      modalImage.src = src;
      modalImage.alt = alt || '';
      modal.hidden = false;
      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');
    }

    function closeModal() {
      if (!modal || !modalImage) return;

      modal.hidden = true;
      modalImage.removeAttribute('src');
      modalImage.alt = '';
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    }

    modalTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var src = trigger.getAttribute('data-modal-image');
        var alt = trigger.getAttribute('data-modal-alt');
        if (src) openModal(src, alt);
      });
    });

    modalCloseEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    if (modal && modalImageWrap) {
      modal.addEventListener('click', function (event) {
        if (!modalImageWrap.contains(event.target)) {
          closeModal();
        }
      });
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });
  });
})();
